import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * Unassigned Tasks list configuration
 * Shows pending tasks with no assigned user
 */
export const unassignedTasksList: ListBuilderList = {
	id: 'unassigned-tasks',
	cacheTTL: 300000,
	name: 'Unassigned',
	type: 'default',
	active: true,
	sortOrder: 7,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskClient',
		'taskClientRep',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'null', label: 'Unassigned' }],
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'next-30-days',
					label: 'Next 30 Days',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:30d}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
